import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c6a32790")

_pushScopeId("data-v-c6a32790")
const _hoisted_1 = { class: "square-buttons" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "circular-border" }
const _hoisted_4 = {
  key: 1,
  class: "content"
}
const _hoisted_5 = { class: "order-info" }
const _hoisted_6 = { class: "delivery-info" }
const _hoisted_7 = { class: "delivery-info" }
const _hoisted_8 = { class: "operation" }
const _hoisted_9 = /*#__PURE__*/_createVNode("h2", null, "Funcionamento", -1)
const _hoisted_10 = { class: "address" }
const _hoisted_11 = /*#__PURE__*/_createVNode("h2", null, "Endereço", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = { class: "tip-payments" }
const _hoisted_14 = { class: "card" }
const _hoisted_15 = { class: "name-card" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "tip-cards" }
const _hoisted_18 = {
  key: 0,
  class: "card pix"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "name-card" }, "Pix", -1)
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "card" }
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "name-card" }, "VISA Crédito", -1)
const _hoisted_23 = { class: "card" }
const _hoisted_24 = /*#__PURE__*/_createVNode("p", { class: "name-card" }, "MASTERCARD Crédito", -1)
const _hoisted_25 = { class: "card" }
const _hoisted_26 = /*#__PURE__*/_createVNode("p", { class: "name-card" }, "HIPERCARD Crédito", -1)
const _hoisted_27 = { class: "card" }
const _hoisted_28 = /*#__PURE__*/_createVNode("p", { class: "name-card" }, "ELO Crédito", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_img = _resolveComponent("ion-img")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_content, null, {
        default: _withId(() => [
          _createVNode("header", null, [
            _createVNode("div", {
              class: "background-image",
              style: {
            backgroundImage: `url(https://storage.googleapis.com/thelivery/img/background/app/${$setup.establishmentInfoRef.background})`,
          }
            }, null, 4),
            _createVNode("div", _hoisted_1, [
              _createVNode(_component_ion_button, {
                fill: "clear",
                onClick: $setup.goBack
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_icon, {
                    icon: $setup.arrowBack,
                    color: "light"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode("div", _hoisted_2, [
                _createVNode("h3", null, _toDisplayString($setup.establishmentInfoRef.name), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_3, [
            ($setup.loadingRef)
              ? (_openBlock(), _createBlock(_component_ion_spinner, { key: 0 }))
              : (_openBlock(), _createBlock("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("p", _hoisted_6, [
                      _createVNode(_component_ion_icon, { icon: $setup.bicycle }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString($setup.establishmentInfoRef.deliveryFee == 0
                  ? "Grátis"
                  : $options.moneyMask($setup.establishmentInfoRef.deliveryFee)), 1)
                    ]),
                    _createVNode("p", _hoisted_7, [
                      _createVNode(_component_ion_icon, { icon: $setup.timeOutline }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString($setup.establishmentInfoRef.averageDeliveryTime) + " min ", 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_8, [
                    _hoisted_9,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.establishmentInfoRef.workingDays, (days) => {
                      return (_openBlock(), _createBlock("span", {
                        key: days.index
                      }, _toDisplayString(days.day) + " das " + _toDisplayString(days.hour), 1))
                    }), 128))
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode("p", null, [
                      _createTextVNode(_toDisplayString($setup.establishmentInfoRef.address +
                ", " +
                $setup.establishmentInfoRef.addressNumber) + " ", 1),
                      _hoisted_12,
                      _createTextVNode(" " + _toDisplayString($setup.establishmentInfoRef.addressNeighborhood), 1)
                    ])
                  ]),
                  _createVNode(_component_ion_list, { class: "payments" }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_13, [
                        _createVNode("h2", null, _toDisplayString($setup.establishmentInfoRef.paymentMethodCategories[0].name), 1),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.establishmentInfoRef
                  .paymentMethodCategories[0].paymentMethods, (paymentMethod) => {
                          return (_openBlock(), _createBlock("div", {
                            key: paymentMethod.id,
                            class: "tip-cards"
                          }, [
                            _createVNode("div", _hoisted_14, [
                              _createVNode(_component_ion_img, {
                                src: `https://thelivery.com.br/static/${paymentMethod.logo}`
                              }, null, 8, ["src"]),
                              _createVNode("p", _hoisted_15, _toDisplayString(paymentMethod.name), 1)
                            ])
                          ]))
                        }), 128)),
                        (
                  $setup.establishmentInfoRef.onlinePayment || $setup.establishmentInfoRef.pix
                )
                          ? (_openBlock(), _createBlock("div", _hoisted_16, [
                              _createVNode("h2", null, _toDisplayString($setup.establishmentInfoRef.paymentMethodCategories[1].name), 1),
                              _createVNode("div", _hoisted_17, [
                                ($setup.establishmentInfoRef.pix)
                                  ? (_openBlock(), _createBlock("div", _hoisted_18, [
                                      _createVNode(_component_ion_img, { src: "assets/logoPix.png" }),
                                      _hoisted_19
                                    ]))
                                  : _createCommentVNode("", true),
                                ($setup.establishmentInfoRef.onlinePayment)
                                  ? (_openBlock(), _createBlock("div", _hoisted_20, [
                                      _createVNode("div", _hoisted_21, [
                                        _createVNode(_component_ion_img, { src: "https://thelivery.com.br/static/assets/layout/card-flags/visa.svg" }),
                                        _hoisted_22
                                      ]),
                                      _createVNode("div", _hoisted_23, [
                                        _createVNode(_component_ion_img, { src: "https://thelivery.com.br/static/assets/layout/card-flags/mastercard.svg" }),
                                        _hoisted_24
                                      ]),
                                      _createVNode("div", _hoisted_25, [
                                        _createVNode(_component_ion_img, { src: "https://thelivery.com.br/static/assets/layout/card-flags/hipercard.svg" }),
                                        _hoisted_26
                                      ]),
                                      _createVNode("div", _hoisted_27, [
                                        _createVNode(_component_ion_img, { src: "https://thelivery.com.br/static/assets/layout/card-flags/elo.svg" }),
                                        _hoisted_28
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ]))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})